import { render, staticRenderFns } from "./Insurance-protection.vue?vue&type=template&id=103bd224&"
import script from "./Insurance-protection.vue?vue&type=script&lang=js&"
export * from "./Insurance-protection.vue?vue&type=script&lang=js&"
import style0 from "./Insurance-protection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports